var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "31368827-F1A9-4232-BB48-56F4C3F92E8B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-163.000000, -632.000000)",
    fill: "#8BA6C1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(163.000000, 632.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6765531,15.7761496 L18.4240309,16.2181712 L22.5592626,20.4046082 C23.1494785,21.0021324 23.1465776,21.9640697 22.5527687,22.5580234 L22.5527687,22.5580234 C21.9637538,23.1471819 21.0086555,23.1472983 20.419497,22.5582834 C20.4172657,22.5560526 20.4150413,22.5538148 20.412824,22.5515701 L16.2775923,18.3651331 L15.8356785,18.6808628 C14.1521888,19.7333003 12.4055945,20.2595112 10.5958431,20.2595112 C7.94434689,20.2595112 5.68219159,19.3123316 3.80930933,17.417944 C1.93642708,15.5235564 1,13.2503253 1,10.5981826 C1,7.94603997 1.93642708,5.68333314 3.80930933,3.80999426 C5.68219159,1.93665539 7.94434689,1 10.5958431,1 C13.2473393,1 15.5094946,1.93665539 17.3823769,3.80999426 C19.2552592,5.68333314 20.1916862,7.94603997 20.1916862,10.5981826 C20.1916862,12.4504728 19.6866469,14.1764445 18.6765531,15.7761496 Z M15.9619396,5.23077788 C14.4888861,3.75736528 12.7002052,3.02067003 10.5958431,3.02067003 C8.49148104,3.02067003 6.7028001,3.75736528 5.22974664,5.23077788 C3.75669318,6.70419047 3.0201775,8.49330751 3.0201775,10.5981826 C3.0201775,12.7030578 3.75669318,14.4921748 5.22974664,15.9655874 C6.7028001,17.439 8.49148104,18.1756953 10.5958431,18.1756953 C12.7002052,18.1756953 14.4888861,17.439 15.9619396,15.9655874 C17.4770803,14.4500773 18.2346393,12.6609603 18.2346393,10.5981826 C18.2346393,8.53540501 17.4770803,6.74628798 15.9619396,5.23077788 Z",
    id: "\\uF4A4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0e49a21bf9445b974a398f7e3fafa8bf.svg";
export { ForwardRef as ReactComponent };